// extracted by mini-css-extract-plugin
module.exports = {"checkList":"RegisterFormTCS_checkList__2WO58","resetButton":"RegisterFormTCS_resetButton__2osn7"};